<template>
  <div class="interface-wrapper">
    <v-card
      class="interface-section-card"
      outlined
      :class="{ 'card-error': interfaceErrors.length > 0 && needInterface }"
    >
      <v-card-text>
        <p class="section-title">Apakah anda ingin menambahkan interface tambahan yang digunakan pada integrasi API?</p>
        <v-row justify="center" class="mt-4 mb-4">
          <v-radio-group v-model="needInterface" row @change="handleNeedInterfaceChange">
            <v-radio label="Tidak" :value="false"></v-radio>
            <v-radio label="Ya" :value="true"></v-radio>
          </v-radio-group>
        </v-row>

        <v-slide-y-reverse-transition>
          <div v-if="needInterface" class="interface-options">
            <div class="interface-container">              
              <div class="checkbox-group mt-3">
                <v-checkbox
                  v-model="selectedInterfaces"
                  label="CPTS"
                  value="cpts"
                  class="mt-0"
                  @change="handleInterfaceChange"
                ></v-checkbox>
                <p class="caption-description">Digunakan untuk transaksi pembayaran menggunakan token CPTS pada integrasi API</p>
              </div>
            </div>
          </div>
        </v-slide-y-reverse-transition>
      </v-card-text>
    </v-card>
    
    <p v-if="interfaceErrors.length > 0 && needInterface" class="field-error-message">
      {{ interfaceErrors[0] }}
    </p>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';

export default {
  name: 'InterfaceField',
  mixins: [validationMixin],

  validations: {
    selectedInterfaces: {
      required() {
        return this.needInterface ? this.selectedInterfaces.length > 0 : true;
      }
    }
  },

  computed: {
    needInterface: {
      set(val) {
        this.$store.commit('register/setNeedInterface', val);
      },
      get() {
        return this.$store.state.register.data.needInterface;
      }
    },

    selectedInterfaces: {
      set(val) {
        this.$store.commit('register/setSelectedInterfaces', val);
      },
      get() {
        return this.$store.state.register.data.qrTypeInterface;
      }
    },

    interfaceErrors() {
      const errors = [];
      if (!this.$v.selectedInterfaces.$dirty) return errors;
      if (!this.$v.selectedInterfaces.required) errors.push('Interface is required');
      return errors;
    }
  },

  methods: {
    handleNeedInterfaceChange(val) {
      if (!val) {
        this.$store.commit('register/setSelectedInterfaces', []);
        this.$v.selectedInterfaces.$reset();
      } else {
        this.$v.selectedInterfaces.$touch();
      }
    },

    handleInterfaceChange() {
      if (this.$v.selectedInterfaces.$dirty) {
        this.$v.selectedInterfaces.$touch();
      }
    },

    touchValidation() {
      this.$v.selectedInterfaces.$touch();
    },

    resetValidation() {
      this.$v.selectedInterfaces.$reset();
    }
  }
};
</script>

<style scoped>
.interface-wrapper {
  width: 80%;
  margin: 24px auto;
}

.interface-section-card {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 4px;
  transition: border-color 0.3s ease;
}

.interface-section-card.card-error {
  border-color: #d32f2f !important;
}

.section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: left;
}

.interface-options {
  margin-top: 16px;
}

.v-slide-y-reverse-transition-enter-active,
.v-slide-y-reverse-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.interface-container {
  width: 100%;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.checkbox-group /deep/ .v-label {
  font-weight: bold;
  font-size: 14px;
}

.caption-description {
  margin: -14px 0 0 36px;
  font-size: 14px;
  color: #666;
  text-align: left;
  line-height: 1.4;
}

.field-error-message {
  color: #d32f2f;
  font-size: 12px;
  margin: 4px 0 0 0;
  text-align: left;
}
</style>
